import React from 'react';
import SiriSpinner from '../shared/SiriSpinner';

const WhatIsBuildPilot = () => {
  return (
    <section className="py-24 bg-neutral-50" data-testid="what-is-buildpilot">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Video */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden">
              <video 
                autoPlay 
                loop 
                muted 
                playsInline
                className="w-full h-auto"
              >
                <source src="/buildpilot-video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <SiriSpinner size="small" />
                <span className="font-semibold text-gray-900">On Track</span>
              </div>
              <p className="text-sm text-gray-500">Your build is progressing well</p>
            </div>
          </div>
          
          {/* Right - Content */}
          <div>
            <h2 className="font-serif text-4xl sm:text-5xl text-gray-900 mb-6">
              Your <span className="gradient-text">co-pilot</span> through the building journey.
            </h2>
            <p className="text-xl text-gray-500 mb-8 leading-relaxed">
              From planning to progress, BuildPilot App helps you navigate your building project with clarity, confidence and control.
            </p>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-violet-600 rounded-full" />
                <span className="text-gray-700">Smart dashboard personalised to your build type and stage</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-violet-600 rounded-full" />
                <span className="text-gray-700">25+ free tools including cost tracker, checklists, and licence checks</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-violet-600 rounded-full" />
                <span className="text-gray-700">Personalised onboarding that adapts to your situation and goals</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-violet-600 rounded-full" />
                <span className="text-gray-700">Built for Australian homeowners with real building industry experience</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsBuildPilot;
